import { c as _c } from "react/compiler-runtime";
import { gql, useMutation } from '@material-bank/graphql-client';
type SaveStatus = {
  __typename?: 'SaveStatus';
  isSaved: boolean;
  folderIds: string[];
};
type UnsaveProductData = {
  unsaveProduct: SaveStatus;
};
type UnsaveProductVars = {
  variantSku: string;
};
const unsaveProductMutation = gql`
  mutation UnsaveProduct($variantSku: String!) {
    unsaveProduct(variantSku: $variantSku) {
      isSaved
      folderIds
    }
  }
`;
export function useUnsaveProductMutation() {
  const $ = _c(5);
  const [mutate, t0] = useMutation(unsaveProductMutation);
  const {
    data,
    loading,
    error
  } = t0;
  const t1 = data?.unsaveProduct ?? null;
  let t2;
  if ($[0] !== error || $[1] !== loading || $[2] !== mutate || $[3] !== t1) {
    t2 = {
      unsaveProduct: mutate,
      data: t1,
      loading,
      error
    };
    $[0] = error;
    $[1] = loading;
    $[2] = mutate;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}